import type { HeadingLevel, TextLevel } from '@lmc/ui-kit'
import { type FormItemProps as AntdFormItemProps, Form } from 'antd'
import CategoryInfo from './CategoryInfo'

export interface FormItemProps<Values> extends AntdFormItemProps<Values> {
  description?: string
  titleLevel?: HeadingLevel
  descriptionLevel?: TextLevel
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const FormItem = <Values = any>(props: FormItemProps<Values>) => {
  const {
    children,
    label,
    description,
    required,
    titleLevel,
    descriptionLevel,
    ...restProps
  } = props

  return (
    <CategoryInfo
      title={label}
      required={required}
      description={description}
      titleLevel={titleLevel}
      descriptionLevel={descriptionLevel}
    >
      <Form.Item<Values> required={required} {...restProps} data-cy="form-item">
        {children}
      </Form.Item>
    </CategoryInfo>
  )
}

export default FormItem
